import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { AttributeListProps } from "@/types";
import { attributesStore } from "@/hooks";
import AttributeGrid from "./AttributeGrid.vue";
import AttributeDisplay from "./AttributeDisplay.vue";


/**
 * Displays a list of generic attributes.
 */
const __default__ = {
  name: "AttributeListDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const attributes = computed(() => props.artifact.attributes || {});

const layout = computed(() =>
  attributesStore.getLayoutByType(props.artifact.type)
);

const doDisplay = computed(() => (layout.value?.positions.length || 0) > 0);

return (_ctx: any,_cache: any) => {
  return (doDisplay.value && !!layout.value)
    ? (_openBlock(), _createBlock(AttributeGrid, {
        key: 0,
        layout: layout.value
      }, {
        item: _withCtx(({ attribute }) => [
          (!!attribute)
            ? (_openBlock(), _createBlock(AttributeDisplay, {
                key: 0,
                "show-name": "",
                values: attributes.value,
                attribute: attribute
              }, null, 8, ["values", "attribute"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["layout"]))
    : _createCommentVNode("", true)
}
}

})